import React, { useState, useEffect, useRef } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import CandidateTab from "./CandidateTab";
import NotificationPanels from "./NotificationPanels";
import "../assets/css/candidate-tab-form.css";
import "../assets/css/inner-tabs.css";
import QuestionIcon from "../assets/img/question-icon.png";
import Footer from "./Footer.js";
import AadhaarLinked from "./AadhaarVerification/AadhaarLinked";
import AadhaarNotLinked from "./AadhaarVerification/AadhaarNotLinked";
import Loader from "./Common/loader";
import { toast } from "react-toastify";
import GetMasterData from "../Helper/masterData";
import StepCount from "./Common/StepCount";
import _ from "lodash";
import ClientSideBar from "./Partials/ClientSideBar";
import ClientHeader from "./Partials/ClientHeader";

import { useDispatch, useSelector } from "react-redux";
import {
  getEAadhaar,
  getEAadhaarCaptchaCode,
  getAadhaarLinkedOTP,
  verifyAadhaarLinkedOTP,
  saveEAadhaar,
  deleteSavedEAadhaarDetails,
  deleteGetAadhaarLinkedOTP,
  deleteVerifyAadhaarLinkedOTP,
  saveEAadhaarDigi,
} from "../Actions/eAadhaarActions";
import {
  uploadFileViaMultipart,
  removeFile,
} from "../Actions/uploadFileActions";
import { useLocation, useNavigate } from "react-router-dom";
import ProgressHeading from "./Common/ProgressHeading.jsx";

const verificationFailedMsg =
  "We can not verify Aadhaar for now. Please continue to fill the required details manually.";

const CandidateAadhaarVerification = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [isAadhaarLinked, setIsAadhaarLinked] = useState(null);
  const [aadhaarVerified, setAadhaarVerified] = useState(false);
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [isAadhaarVerifiedViaOTP, setIsAadhaarVerifiedViaOTP] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [eAadhaarData, setEAadhaarData] = useState({});
  const [verifiedAadhaarData, setVerifiedAadhaarData] = useState({});
  const [captchaData, setCaptchaData] = useState({});
  const [aadhaarNumber, setAadhaarNumber] = useState("");
  const [aadhaarPreviews, setAadhaarPreviews] = useState({});
  const [aadhaarAlreadyVerified, setIsAadhaarAlreadyVerified] = useState(false);
  const [unsavedAadhaarData, setUnsavedAadhaarData] = useState({});
  const [role,setRole]=useState();

  const storeData = useSelector((state) => state.eAadhaar);
  const { eAadhaarData: eAadhaarDataStore, loading: eAadhaarDataLoading } =
    storeData;

  const storeData2 = useSelector((state) => state.eAadhaarCaptcha);
  const { eAadhaarCaptchaData, loading: eAadhaarCaptchaDataLoading } =
    storeData2;

  const storeData3 = useSelector((state) => state.eAadhaarOTP);
  const { aadhaarLinkedOTPData, loading: aadhaarLinkedOTPDataLoading } =
    storeData3;

  const storeData4 = useSelector((state) => state.verifiedEAadhaarData);
  const {
    verifiedAadhaarLinkedOTPData,
    loading: verifiedAadhaarLinkedOTPDataLoading,
  } = storeData4;

  const storeData5 = useSelector((state) => state.eAadhaarSaved);
  const { eAadhaarSavedData, loading: eAadhaarSavedDataLoading } = storeData5;

  let user = JSON.parse(localStorage.getItem('userVerificationCandidate'));
  let clientId;

  if(user && (user?.client_id || user?.bridge_client_id)){
    clientId = user?.client_id || user?.bridge_client_id;  
  }

  useEffect(() => {
    window.scroll({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      dispatch(getEAadhaar());
      console.log("location......", location?.state)
      if(location?.state?.eAadhaarDigilocker) {
        setAadhaarVerified(false);
        handleSaveDisabled(true);
        dispatch(saveEAadhaarDigi({
          ts_trans_id : location?.state?.transId
        }))
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (
      typeof eAadhaarDataLoading !== "undefined" &&
      eAadhaarDataLoading !== null
    ) {
      if (eAadhaarDataLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
      }
    }
  }, [eAadhaarDataStore, storeData]);

  useEffect(() => {
    if (Object.keys(eAadhaarDataStore).length > 0 && eAadhaarDataStore.data) {
      setEAadhaarData(eAadhaarDataStore.data);
      handlePreviewData(eAadhaarDataStore.data);
      checkIfEAadhaarLinked(eAadhaarDataStore.data);
    } else {
      if (eAadhaarDataStore.code && eAadhaarDataStore.code === 400) {
        const msg = eAadhaarDataStore.message;
        toast.error(msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        const localData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
        navigate(
          `/case-initiation/check-detail/${localData.reference_number}/profile`
        );
      }
    }
  }, [eAadhaarDataStore, storeData]);

  useEffect(() => {
    if (
      typeof eAadhaarSavedDataLoading !== "undefined" &&
      eAadhaarSavedDataLoading !== null
    ) {
      if (eAadhaarSavedDataLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
      }
    }
  }, [eAadhaarSavedData, storeData5]);

  useEffect(() => {
    const hasReferenceNumber =
      eAadhaarSavedData && eAadhaarSavedData.data ? true : false;
    if (hasReferenceNumber) {
      const referenceNumber = eAadhaarSavedData.data.reference_number;
      const groupID = eAadhaarSavedData.data.group.group_id;
      if (groupID && groupID === "profile_preview") {
        navigate(`/case-initiation/profile-preview/${referenceNumber}`);
      } else {
        navigate(`/case-initiation/check-detail/${referenceNumber}/${groupID}`);
      }
      dispatch(deleteSavedEAadhaarDetails());
    }
  }, [eAadhaarSavedData, storeData5]);

  useEffect(() => {
    if (
      typeof eAadhaarCaptchaDataLoading !== "undefined" &&
      eAadhaarCaptchaDataLoading !== null
    ) {
      if (eAadhaarCaptchaDataLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
      }
    }
  }, [eAadhaarCaptchaData]);

  const autoLoginStore = useSelector((state) => state.autoLogin);
  const { autoLoginData, loadingLogin } = autoLoginStore;

  useEffect(() => {
    if (
      typeof autoLoginData?.status !== "undefined" &&
      autoLoginData?.status !== null
    ) {
      
     setRole(autoLoginData.data.user_role);
    }
  }, [autoLoginData, autoLoginStore]);

  useEffect(() => {
    if (
      typeof aadhaarLinkedOTPDataLoading !== "undefined" &&
      aadhaarLinkedOTPDataLoading !== null
    ) {
      if (aadhaarLinkedOTPDataLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
      }
    }
  }, [aadhaarLinkedOTPData]);

  useEffect(() => {
    if (
      aadhaarLinkedOTPData &&
      typeof aadhaarLinkedOTPData.data !== "undefined" &&
      aadhaarLinkedOTPData.data !== null
    ) {
      if (aadhaarLinkedOTPData.data.status == "success") {
        setAadhaarVerified(true);
      }
      if (aadhaarLinkedOTPData.data.status == "failed") {
        const message = aadhaarLinkedOTPData.data.msg;
        let errMsg = "";
        if (message.includes("attempt")) {
          errMsg = verificationFailedMsg;
          setIsAadhaarLinked("No");
        } else {
          errMsg = message;
        }
        toast.error(errMsg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      dispatch(deleteGetAadhaarLinkedOTP());
    }
  }, [aadhaarLinkedOTPData, storeData3]);

  useEffect(() => {
    if (
      typeof verifiedAadhaarLinkedOTPDataLoading !== "undefined" &&
      verifiedAadhaarLinkedOTPDataLoading !== null
    ) {
      if (verifiedAadhaarLinkedOTPDataLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
      }
    }
  }, [verifiedAadhaarLinkedOTPData]);

  useEffect(() => {
    if (
      verifiedAadhaarLinkedOTPData &&
      typeof verifiedAadhaarLinkedOTPData.data !== "undefined" &&
      verifiedAadhaarLinkedOTPData.data !== null
    ) {
      if (verifiedAadhaarLinkedOTPData.data.status == "success") {
        setIsAadhaarVerifiedViaOTP(true);
        setVerifiedAadhaarData(verifiedAadhaarLinkedOTPData.data);
      }
      if (verifiedAadhaarLinkedOTPData.data.status == "failed") {
        const message = verifiedAadhaarLinkedOTPData.data.msg;
        let errMsg = "";
        if (message.includes("attempt")) {
          errMsg = verificationFailedMsg;
          setIsAadhaarLinked("No");
        } else {
          errMsg = message;
        }
        toast.error(errMsg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      dispatch(deleteVerifyAadhaarLinkedOTP());
    }
  }, [verifiedAadhaarLinkedOTPData, storeData4]);

  useEffect(() => {
    if (
      typeof eAadhaarCaptchaData.data !== "undefined" &&
      eAadhaarCaptchaData.data !== null
    ) {
      setCaptchaData(eAadhaarCaptchaData.data);
    }
  }, [eAadhaarCaptchaData, storeData2]);

  const checkIfEAadhaarLinked = (eData) => {
    const val =
      eData.checksDetails[0].fields.is_mobile_linked_aadhar.field_value;
    const fields = eData.checksDetails[0].fields;
    if (val == "1") {
      setIsAadhaarLinked("Yes");
      setIsAadhaarAlreadyVerified(true);
      handleAlreadyVerifiedDetails(fields);
      setSaveDisabled(false);
    }
    if (val == "2") {
      setIsAadhaarLinked("No");
      setIsAadhaarAlreadyVerified(false);
      handleAlreadyVerifiedDetails(fields);
      setSaveDisabled(false);
    }
  };

  const handleAlreadyVerifiedDetails = (fields) => {
    if (Object.keys(unsavedAadhaarData).length == 0) {
      let data = {};
      data["aadhar_address"] = fields.address ? fields.address.field_value : "";
      data["aadhar_name"] = fields.candidate_name_aadhar
        ? fields.candidate_name_aadhar.field_value
        : "";
      data["aadhar_dob"] = fields.date_of_birth
        ? fields.date_of_birth.field_value
        : "";
      data["aadhar_father_name"] = fields.dependent_father_name
        ? fields.dependent_father_name.field_value
        : "";
      data["aadhar_gender"] = fields.gender ? fields.gender.field_value : "";
      data["aadhar_number"] = fields.aadhar_card_number
        ? fields.aadhar_card_number.field_value
        : "";
      setVerifiedAadhaarData(data);
    } else {
      setVerifiedAadhaarData(unsavedAadhaarData);
    }
  };
  const handlePreviewData = (eData) => {
    const previewData = {};
    if (eData.checksDetails[0].uploaded_documents) {
      for (var i in eData.checksDetails[0].uploaded_documents) {
        const docSide = eData.checksDetails[0].uploaded_documents[i];
        for (var j in docSide) {
          previewData[`${i}`] = docSide[j].preview_key
            ? docSide[j].preview_key
            : "n.a.";
        }
      }
    }
    setAadhaarPreviews(previewData);
  };

  const handleIsAadhaarLinked = (e) => {
    setIsAadhaarLinked(e.target.value);
    if (e.target.value == "Yes") {
      dispatch(getEAadhaarCaptchaCode());
      setAadhaarVerified(false);
      handleSaveDisabled(true);
    }
    if (e.target.value == "No") {
      // setVerifiedAadhaarData({});
      const fields = eAadhaarData.checksDetails[0].fields;
      handleAlreadyVerifiedDetails(fields);
      setIsAadhaarVerifiedViaOTP(false);
      setAadhaarVerified(false);
    }
  };

  const verifyAadhaar = (aadhaarData) => {
    setAadhaarNumber(aadhaarData.aadhaarNumber);
    const aadhaarRecord = {
      aadhaarNumber: aadhaarData.aadhaarNumber,
      captchaCode: aadhaarData.captchaCode,
      tsTransID: captchaData.tsTransID,
      secretToken: captchaData.secretToken,
    };
    localStorage.setItem("eAadhaarDigiData", JSON.stringify({
      tsTransID: captchaData?.tsTransID || "",
      initial_case_id: eAadhaarData?.candidates?.initial_case_id || ""
    }))
    dispatch(getAadhaarLinkedOTP(aadhaarRecord , getAadhaarLinkedOTPResponse));
  };

  const getAadhaarLinkedOTPResponse = (data) => {
    console.log("aadhar response...", data?.data?.url)
    if(data?.data?.url) {
      window.location.href = data?.data?.url;
      // navigate(data?.data?.url, { replace: true })
    }
  }

  const verifyOTPHandler = (otp) => {
    const otpDetails = {
      otp: otp,
      tsTransID: captchaData.tsTransID,
    };
    dispatch(verifyAadhaarLinkedOTP(otpDetails));
  };

  const handleSaveDisabled = (val, data = null) => {
    if (val == false && data) {
      const isEqual = _.isEqual(verifiedAadhaarData, data);
      const dobData =
        eAadhaarData.checksDetails[0].fields.date_of_birth.field_value;
      if (isEqual == false && data.aadhar_dob !== dobData) {
        setVerifiedAadhaarData(data);
      }
    }
    setSaveDisabled(val);
  };

  const handleSave = (e) => {
    e.preventDefault();
    let savedDetails = {};
    savedDetails["group"] = "e_aadhar";
    savedDetails[
      eAadhaarData.checksDetails[0].fields["aadhar_card_number"].id
    ] = verifiedAadhaarData.aadhar_number
      ? verifiedAadhaarData.aadhar_number
      : aadhaarNumber;
    savedDetails[eAadhaarData.checksDetails[0].fields["address"].id] =
      verifiedAadhaarData.aadhar_address
        ? verifiedAadhaarData.aadhar_address
        : "";
    savedDetails[
      eAadhaarData.checksDetails[0].fields["candidate_name_aadhar"].id
    ] = verifiedAadhaarData.aadhar_name ? verifiedAadhaarData.aadhar_name : "";
    savedDetails[eAadhaarData.checksDetails[0].fields["date_of_birth"].id] =
      verifiedAadhaarData.aadhar_dob ? verifiedAadhaarData.aadhar_dob : "";
    savedDetails[
      eAadhaarData.checksDetails[0].fields["dependent_father_name"].id
    ] = verifiedAadhaarData.aadhar_father_name
      ? verifiedAadhaarData.aadhar_father_name
      : "";
    savedDetails[eAadhaarData.checksDetails[0].fields["gender"].id] =
      verifiedAadhaarData.aadhar_gender
        ? verifiedAadhaarData.aadhar_gender
        : "";
    savedDetails[
      eAadhaarData.checksDetails[0].fields["is_mobile_linked_aadhar"].id
    ] = isAadhaarLinked == "Yes" ? "1" : "2";
    let finalData = {};
    const caseCheckID = eAadhaarData.checksDetails[0].case_check_id;
    finalData[`${caseCheckID}`] = savedDetails;
    dispatch(saveEAadhaar(caseCheckID, finalData));
  };

  const handleFileUpload = async (mode, file, record, unsavedData) => {
    setUnsavedAadhaarData(unsavedData);
    await dispatch(uploadFileViaMultipart(mode, file, record));
    await dispatch(getEAadhaar());
  };

  const removeFileHandler = async (mode, record, unsavedData) => {
    setUnsavedAadhaarData(unsavedData);
    await dispatch(removeFile(mode, record));
    await dispatch(getEAadhaar());
  };

  const handleCaptchaReload = () => {
    dispatch(getEAadhaarCaptchaCode());
  };

  const handleOTPBack = (e) => {
    e.preventDefault();
    setAadhaarVerified(false);
  };

  const handleSubmitForPreview = (e) => {
    e.preventDefault();
    const currentUrl = window.location.href;
    const [partA, partB] = currentUrl.split("/check-detail/");
    const [reference, route] = partB.split("/");
    navigate(`/case-initiation/profile-preview/${reference}`);
  };
  const { genderOptions } = GetMasterData();

  return (
    <>
      <NotificationPanels />
      {role=="EP"? <ClientHeader />:<Header/>}
      {role=="EP"? <ClientSideBar /> :<Sidebar/>}
      {/* <Header />
      <Sidebar /> */}

      <section
        className="main-section candidate-tab-form"
        style={{ paddingTop: "60px" }}
      >
        {isLoading && <Loader />}
        <div className="container-fluid">
          <div className="row">
            <div className="col-auto w-100-mbl bg-gray-mbl">
             <ProgressHeading/>
              <CandidateTab activeTab={"Aadhaar e-KYC verification"} />
            </div>
            <div className="col bg-gray-mbl">
              <form
                className="p-3 form2 form-section"
                style={{ minHeight: "700px" }}
              >
                <StepCount activeTab={"Aadhaar e-KYC verification"} />
                <h2 className="fnt-smi-bld">Aadhaar Card Verification</h2>
                <p className="text-muted">
                  Please enter your details to verify your aadhaar card.
                </p>
                <hr />
                <div className="step-1">
                  <h6 className="fnt-smi-bld mb-3">
                    Is your mobile number linked with aadhaar?
                    {/* <img src={QuestionIcon} alt="" className="ml-2" /> */}
                  </h6>
                  <div className="row mb-3">
                    <div className="col-sm-4 col-md-12 col-xl-4">
                      <div className="form-check form-check-inline mr-4">
                        <input
                          type="radio"
                          className="form-check-input"
                          name="mblLinkedYesNo"
                          id="mblLinkedYes"
                          value="Yes"
                          onChange={handleIsAadhaarLinked}
                          checked={isAadhaarLinked == "Yes" ? true : false}
                          disabled={aadhaarAlreadyVerified}
                        />
                        <label
                          htmlFor="mblLinkedYes"
                          className="form-check-label"
                        >
                          Yes
                        </label>
                      </div>

                      <div className="form-check form-check-inline">
                        <input
                          type="radio"
                          className="form-check-input"
                          name="mblLinkedYesNo"
                          id="mblLinkedNo"
                          value="No"
                          onChange={handleIsAadhaarLinked}
                          checked={isAadhaarLinked == "No" ? true : false}
                          disabled={aadhaarAlreadyVerified}
                        />
                        <label
                          htmlFor="mblLinkedNo"
                          className="form-check-label"
                        >
                          No
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                {aadhaarAlreadyVerified && (
                  <div className="mt-2 mb-2">
                    <small className="text-danger">
                      Aadhaar Number has already been verified. This cannot be
                      edited.
                    </small>
                  </div>
                )}
                {isAadhaarLinked == "Yes" ? (
                  isAadhaarVerifiedViaOTP == false &&
                  aadhaarAlreadyVerified == false ? (
                    <AadhaarLinked
                      captchaData={captchaData}
                      aadhaarVerified={aadhaarVerified}
                      verifyAadhaar={verifyAadhaar}
                      verifyOTPHandler={verifyOTPHandler}
                      genderOptions={genderOptions}
                      handleCaptchaReload={handleCaptchaReload}
                      handleOTPBack={handleOTPBack}
                    />
                  ) : (
                    <></>
                  )
                ) : (
                  <></>
                )}

                {(isAadhaarLinked == "No" ||
                  isAadhaarVerifiedViaOTP == true ||
                  aadhaarAlreadyVerified == true) && (
                  <AadhaarNotLinked
                    verifiedAadhaarData={verifiedAadhaarData}
                    isAadhaarVerifiedViaOTP={isAadhaarVerifiedViaOTP}
                    aadhaarNumber={aadhaarNumber}
                    genderOptions={genderOptions}
                    handleSaveDisabled={handleSaveDisabled}
                    eAadhaarData={eAadhaarData}
                    handleFileUpload={handleFileUpload}
                    removeFile={removeFileHandler}
                    aadhaarPreviews={aadhaarPreviews}
                    aadhaarAlreadyVerified={aadhaarAlreadyVerified}
                    dateOfBirth={eAadhaarData.date_of_birth}
                  />
                )}

                <div className="row mt-3">
                  <div className="col-auto d-flex justify-content-between">
                    {aadhaarVerified == true && isAadhaarLinked == "Yes" && (
                      <button
                        className="btn btn-outline-secondary btn-lg btn-block mt-3 mr-2"
                        onClick={(e) => handleOTPBack(e)}
                      >
                        Back
                      </button>
                    )}
                    <button
                      className="btn btn-primary btn-lg btn-block mt-3"
                      disabled={saveDisabled}
                      onClick={(e) => handleSave(e)}
                    >
                      Save
                    </button>
                  </div>
                </div>
                {Object.keys(eAadhaarData).length > 0 &&
                  eAadhaarData.showProfilePreview == 1 && (
                    <div className="row">
                      <div className="col-auto d-flex justify-content-between">
                        <button
                          className="btn btn-primary btn-lg btn-block mt-3"
                          onClick={(e) => handleSubmitForPreview(e)}
                        >
                          {clientId == 459831 ? "Preview" : "Submit for Preview"}
                        </button>
                      </div>
                      <div className="col-auto d-flex justify-content-between mt-4">
                        <small className="text-muted">
                          Please complete all the mandatory fields before final
                          submission
                        </small>
                      </div>
                    </div>
                  )}
              </form>

              <Footer />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default CandidateAadhaarVerification;
